(function () {
  const SCROLL_KEY = "pukara_match_quiz_scroll_y";

  function rememberScroll() {
    try { sessionStorage.setItem(SCROLL_KEY, String(window.scrollY || 0)); } catch (e) {}
  }

  function restoreScroll() {
    try {
      const v = sessionStorage.getItem(SCROLL_KEY);
      if (v === null) return;
      sessionStorage.removeItem(SCROLL_KEY);
      const y = Math.max(0, parseInt(v, 10) || 0);
      requestAnimationFrame(() => requestAnimationFrame(() => window.scrollTo(0, y)));
    } catch (e) {}
  }

  function cleanRecipeTitle(s) {
    const t = (s || "").replace(/\s+/g, " ").trim();
    return t.replace(/^Article\s+/i, "").replace(/\s+View Article$/i, "").trim();
  }

  function isBlogIndexUrl(url) {
    if (!url) return true;
    const u = url.split("?")[0].replace(/\/+$/, "");
    return /^\/blogs\/[^/]+$/i.test(u);
  }

  function isRecipesBlogIndex(url) {
    if (!url) return false;
    const u = url.split("?")[0].replace(/\/+$/, "");
    return u.toLowerCase() === "/blogs/recipes";
  }

  function buildDiscountedRedirectUrl(discountCode, targetUrl) {
    try {
      const u = new URL(targetUrl, window.location.origin);
      const path = u.pathname + (u.search || "");
      return `/discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(path)}`;
    } catch (e) {
      return targetUrl;
    }
  }

  function formatMoneyFromCents(cents) {
    if (typeof cents !== "number") return "";
    const dollars = (cents / 100).toFixed(2);
    return "$" + dollars;
  }

  async function fetchProductJsonByUrl(productUrl) {
    const u = new URL(productUrl, window.location.origin);
    const jsUrl = u.pathname.replace(/\/+$/, "") + ".js";
    const res = await fetch(jsUrl, { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("Product JSON fetch failed: " + res.status);
    return await res.json();
  }

  async function hydrateProduct(p) {
    const needsImage = !p.image || !String(p.image).trim();
    const needsVariant = !p.variant_id || Number(p.variant_id) === 0;
    const needsPrice = !p.price_formatted || !String(p.price_formatted).trim();

    if (!needsImage && !needsVariant && !needsPrice) return p;

    const prod = await fetchProductJsonByUrl(p.url);

    if (needsImage) {
      p.image = prod.featured_image || (prod.images && prod.images[0]) || p.image || "";
    }

    if (needsVariant) {
      const v0 = prod.variants && prod.variants[0];
      if (v0 && v0.id) p.variant_id = v0.id;
    }

    if (needsPrice) {
      const v0 = prod.variants && prod.variants[0];
      const cents = (v0 && typeof v0.price === "number") ? v0.price : prod.price;
      if (typeof cents === "number") p.price_formatted = formatMoneyFromCents(cents);
    }

    if (!p.title && prod.title) p.title = prod.title;

    return p;
  }

  function buildStepsMarkup() {
    return `
      <fieldset class="pukara-premium-quiz__q" data-q="2" hidden>
        <legend class="pukara-premium-quiz__qtitle">Pick your flavour direction.</legend>
        <div class="pukara-premium-quiz__tiles">
          <label class="pukara-tile"><input type="radio" name="q2" value="herbaceous" required><span class="pukara-tile__inner"><span class="pukara-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M6 20c6 0 12-6 12-12-6 0-12 6-12 12Z" stroke="currentColor" stroke-width="1.6"/><path d="M6 20c0-6 6-12 12-12" stroke="currentColor" stroke-width="1.6"/></svg></span><span class="pukara-tile__title">Herbaceous</span><span class="pukara-tile__desc">Green, aromatic, bright</span></span></label>
          <label class="pukara-tile"><input type="radio" name="q2" value="citrus"><span class="pukara-tile__inner"><span class="pukara-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M12 21a9 9 0 100-18 9 9 0 000 18Z" stroke="currentColor" stroke-width="1.6"/><path d="M12 3v18M3 12h18" stroke="currentColor" stroke-width="1.6"/></svg></span><span class="pukara-tile__title">Citrus</span><span class="pukara-tile__desc">Lifted, clean, vibrant</span></span></label>
          <label class="pukara-tile"><input type="radio" name="q2" value="rich"><span class="pukara-tile__inner"><span class="pukara-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M7 10c0-4 10-4 10 0v7c0 3-10 3-10 0v-7Z" stroke="currentColor" stroke-width="1.6"/><path d="M7 14h10" stroke="currentColor" stroke-width="1.6"/></svg></span><span class="pukara-tile__title">Indulgent</span><span class="pukara-tile__desc">Rich, layered, luxurious</span></span></label>
          <label class="pukara-tile"><input type="radio" name="q2" value="smoky"><span class="pukara-tile__inner"><span class="pukara-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M8 13c-2 0-3 1.5-3 3s1 3 3 3h8c2 0 3-1.5 3-3s-1-3-3-3" stroke="currentColor" stroke-width="1.6"/><path d="M9 12c0-1.5 1-2 1-3s-1-1.5-1-3" stroke="currentColor" stroke-width="1.6"/><path d="M15 12c0-1.5 1-2 1-3s-1-1.5-1-3" stroke="currentColor" stroke-width="1.6"/></svg></span><span class="pukara-tile__title">Smoky</span><span class="pukara-tile__desc">Depth, savoury warmth</span></span></label>
          <label class="pukara-tile"><input type="radio" name="q2" value="heat"><span class="pukara-tile__inner"><span class="pukara-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M12 22c4 0 7-3 7-7 0-4-3-5-3-9-2 2-2 4-4 5-2-1-2-3-4-5 0 4-3 5-3 9 0 4 3 7 7 7Z" stroke="currentColor" stroke-width="1.6"/></svg></span><span class="pukara-tile__title">Warm heat</span><span class="pukara-tile__desc">Spice, controlled intensity</span></span></label>
        </div>
      </fieldset>

      <fieldset class="pukara-premium-quiz__q" data-q="3" hidden>
        <legend class="pukara-premium-quiz__qtitle">What are you most likely making?</legend>
        <div class="pukara-premium-quiz__tiles">
          <label class="pukara-tile"><input type="radio" name="q3" value="salads" required><span class="pukara-tile__inner"><span class="pukara-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M5 12c1-5 13-5 14 0-1 7-13 7-14 0Z" stroke="currentColor" stroke-width="1.6"/><path d="M8 8c1-2 3-3 4-3s3 1 4 3" stroke="currentColor" stroke-width="1.6"/></svg></span><span class="pukara-tile__title">Salads</span><span class="pukara-tile__desc">Vegetables, bowls, dressings</span></span></label>
          <label class="pukara-tile"><input type="radio" name="q3" value="pasta"><span class="pukara-tile__inner"><span class="pukara-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M6 7h12v6a6 6 0 01-6 6H6V7Z" stroke="currentColor" stroke-width="1.6"/><path d="M9 11h6" stroke="currentColor" stroke-width="1.6"/></svg></span><span class="pukara-tile__title">Italian</span><span class="pukara-tile__desc">Pasta, pizza, tomatoes</span></span></label>
          <label class="pukara-tile"><input type="radio" name="q3" value="seafood"><span class="pukara-tile__inner"><span class="pukara-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M4 12s3-5 8-5 8 5 8 5-3 5-8 5-8-5-8-5Z" stroke="currentColor" stroke-width="1.6"/><path d="M12 12h.01" stroke="currentColor" stroke-width="2.2"/></svg></span><span class="pukara-tile__title">Seafood</span><span class="pukara-tile__desc">Fresh proteins, light finishes</span></span></label>
          <label class="pukara-tile"><input type="radio" name="q3" value="bbq"><span class="pukara-tile__inner"><span class="pukara-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M6 10h12l-1 10H7L6 10Z" stroke="currentColor" stroke-width="1.6"/><path d="M8 10V7a4 4 0 018 0v3" stroke="currentColor" stroke-width="1.6"/></svg></span><span class="pukara-tile__title">BBQ</span><span class="pukara-tile__desc">Grilled dishes, marinades</span></span></label>
          <label class="pukara-tile"><input type="radio" name="q3" value="finishing"><span class="pukara-tile__inner"><span class="pukara-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M7 20h10" stroke="currentColor" stroke-width="1.6"/><path d="M9 20c0-7 6-7 6-14H9c0 7 0 7 0 14Z" stroke="currentColor" stroke-width="1.6"/></svg></span><span class="pukara-tile__title">Finishing</span><span class="pukara-tile__desc">Cheese boards, final drizzle</span></span></label>
        </div>
      </fieldset>

      <fieldset class="pukara-premium-quiz__q" data-q="4" hidden>
        <legend class="pukara-premium-quiz__qtitle">How do you feel about sweetness in vinegar?</legend>
        <div class="pukara-premium-quiz__tiles">
          <label class="pukara-tile"><input type="radio" name="q4" value="classic" required><span class="pukara-tile__inner"><span class="pukara-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M7 7h10v14H7V7Z" stroke="currentColor" stroke-width="1.6"/><path d="M9 3h6v4H9V3Z" stroke="currentColor" stroke-width="1.6"/></svg></span><span class="pukara-tile__title">Classic</span><span class="pukara-tile__desc">Less sweet, more traditional</span></span></label>
          <label class="pukara-tile"><input type="radio" name="q4" value="balanced"><span class="pukara-tile__inner"><span class="pukara-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M12 4v16" stroke="currentColor" stroke-width="1.6"/><path d="M6 8h12M6 16h12" stroke="currentColor" stroke-width="1.6"/></svg></span><span class="pukara-tile__title">Balanced</span><span class="pukara-tile__desc">Sweetness in restraint</span></span></label>
          <label class="pukara-tile"><input type="radio" name="q4" value="rich"><span class="pukara-tile__inner"><span class="pukara-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M8 10c0-3 8-3 8 0v8c0 3-8 3-8 0v-8Z" stroke="currentColor" stroke-width="1.6"/><path d="M9 6h6" stroke="currentColor" stroke-width="1.6"/></svg></span><span class="pukara-tile__title">Rich</span><span class="pukara-tile__desc">Full-bodied sweetness</span></span></label>
        </div>
      </fieldset>

      <fieldset class="pukara-premium-quiz__q" data-q="5" hidden>
        <legend class="pukara-premium-quiz__qtitle">Choose the moment.</legend>
        <div class="pukara-premium-quiz__tiles">
          <label class="pukara-tile"><input type="radio" name="q5" value="weeknight" required><span class="pukara-tile__inner"><span class="pukara-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M7 4h10v16H7V4Z" stroke="currentColor" stroke-width="1.6"/><path d="M9 8h6M9 12h6M9 16h6" stroke="currentColor" stroke-width="1.6"/></svg></span><span class="pukara-tile__title">Weeknight</span><span class="pukara-tile__desc">Fast, high-reward cooking</span></span></label>
          <label class="pukara-tile"><input type="radio" name="q5" value="longlunch"><span class="pukara-tile__inner"><span class="pukara-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M6 20h12" stroke="currentColor" stroke-width="1.6"/><path d="M8 20V9a4 4 0 018 0v11" stroke="currentColor" stroke-width="1.6"/><path d="M9 6h6" stroke="currentColor" stroke-width="1.6"/></svg></span><span class="pukara-tile__title">Long lunch</span><span class="pukara-tile__desc">Table-first, generous sharing</span></span></label>
          <label class="pukara-tile"><input type="radio" name="q5" value="datenight"><span class="pukara-tile__inner"><span class="pukara-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M12 21s-7-4.5-7-10a4 4 0 017-2 4 4 0 017 2c0 5.5-7 10-7 10Z" stroke="currentColor" stroke-width="1.6"/></svg></span><span class="pukara-tile__title">Date night</span><span class="pukara-tile__desc">Elevated, intentional flavour</span></span></label>
          <label class="pukara-tile"><input type="radio" name="q5" value="summer" required><span class="pukara-tile__inner"><span class="pukara-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M12 3v18" stroke="currentColor" stroke-width="1.6"/><path d="M5 12h14" stroke="currentColor" stroke-width="1.6"/><path d="M7 7l10 10M17 7L7 17" stroke="currentColor" stroke-width="1.6"/></svg></span><span class="pukara-tile__title">Summer table</span><span class="pukara-tile__desc">Fresh, bright, clean</span></span></label>
          <label class="pukara-tile"><input type="radio" name="q5" value="winter"><span class="pukara-tile__inner"><span class="pukara-tile__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M12 2v20" stroke="currentColor" stroke-width="1.6"/><path d="M5 7h14M6 12h12M5 17h14" stroke="currentColor" stroke-width="1.6"/></svg></span><span class="pukara-tile__title">Winter comfort</span><span class="pukara-tile__desc">Depth, warmth, richness</span></span></label>
        </div>
      </fieldset>
    `;
  }

  function initQuiz(root) {
    const uid = root.id;
    const discountCode = root.getAttribute("data-discount-code") || "VALENTINE15";
    const get = (suffix) => document.getElementById(uid + suffix);

    const stage = get("-Stage");

    const mount = get("-StepsMount");
    if (mount && !mount.dataset.injected) {
      mount.innerHTML = buildStepsMarkup();
      mount.dataset.injected = "true";
    }

    const dataEl = get("-ProductData");
    const products = dataEl ? JSON.parse(dataEl.textContent) : {};

    const form = get("-Form");
    const errorEl = get("-Error");
    const backBtn = get("-Back");
    const nextBtn = get("-Next");
    const progressEl = get("-Progress");
    const stepLabel = get("-StepLabel");

    const panelWrap = get("-Panel");
    const resultWrap = get("-Result");

    const resultTitle = get("-ResultTitle");
    const resultCopy = get("-ResultCopy");
    const whyEl = get("-Why");

    const oilLink = get("-OilLink");
    const oilImg = get("-OilImg");
    const oilTitle = get("-OilTitle");
    const oilPrice = get("-OilPrice");
    const oilBuy = get("-OilBuy");

    const vinLink = get("-VinLink");
    const vinImg = get("-VinImg");
    const vinTitle = get("-VinTitle");
    const vinPrice = get("-VinPrice");
    const vinBuy = get("-VinBuy");

    const codeWrap = get("-CodeWrap");
    const codeField = get("-CodeField");
    const copyBtn = get("-Copy");
    const statusEl = get("-Status");
    const restartBtn = get("-Restart");

    const recipesWrap = get("-RecipesWrap");
    const oilRecipesTitle = get("-OilRecipesTitle");
    const vinRecipesTitle = get("-VinRecipesTitle");
    const oilRecipesList = get("-OilRecipesList");
    const vinRecipesList = get("-VinRecipesList");
    const oilRecipesMore = get("-OilRecipesMore");
    const vinRecipesMore = get("-VinRecipesMore");

    if (!form || !nextBtn || !panelWrap || !resultWrap) return;

    if (codeField) codeField.value = discountCode;
    window.addEventListener("beforeunload", rememberScroll, { passive: true });

    const RESULTS = {
      classic: { title: "Classic and Versatile", oil: "premium-extra-virgin-olive-oil", vinegar: "caramelised-balsamic-vinegar",
        copy: "Balanced, dependable, and quietly impressive. A pairing that moves effortlessly from simple salads to finishing a plate at the table.",
        why: ["Ideal for dipping with crusty bread and finishing vegetables.","Sweet-tangy balsamic lifts without overpowering.","A reliable foundation for dressings, marinades, and everyday cooking."] },

      italian: { title: "Italian Night In", oil: "garlic-extra-virgin-olive-oil", vinegar: "barrel-aged-balsamic-vinegar",
        copy: "Savoury and composed. Garlic-infused olive oil delivers immediate aroma, with barrel-aged balsamic adding structure and balance rather than sweetness.",
        why: ["Builds quick flavour for pasta, pizza, and roasted vegetables.","Traditional balsamic profile suited to cooking from scratch.","Excellent in marinades and warm dressings."] },

      summer_table: { title: "Summer Table", oil: "basil-extra-virgin-olive-oil", vinegar: "white-balsamic-vinegar",
        copy: "Fresh, green, and clean. Basil olive oil and white balsamic keep the finish bright and modern, designed for lighter dishes and clean plating.",
        why: ["Made for tomatoes, chicken, and simple salads.","White balsamic keeps flavours light and defined.","A natural fit for entertaining."] },

      bright_fresh: { title: "Bright and Fresh", oil: "lemon-extra-virgin-olive-oil", vinegar: "white-wine-liqueur-vinegar",
        copy: "Citrus and clarity. Lemon olive oil brings a clean lift, paired with white wine liqueur vinegar for crisp acidity across seafood, salads, and lighter cooking.",
        why: ["Excellent with seafood, chicken, and fresh vegetables.","Bright acidity for dressings and quick pickling.","A clean finish that stays light on the palate."] },

      tropical_bright: { title: "Tropical Bright", oil: "lemon-extra-virgin-olive-oil", vinegar: "guava-vinegar",
        copy: "Bright and modern with an aromatic fruit edge. Lemon olive oil keeps the finish clean, while guava vinegar adds a fresh, fruit-led lift.",
        why: ["Ideal for salads, seafood, and lighter marinades.","Guava adds fruit complexity without heaviness.","A sharp, clean finish designed for modern plates."] },

      pomegranate_classic: { title: "Pomegranate and Classic", oil: "premium-extra-virgin-olive-oil", vinegar: "pomegranate-balsamic-vinegar",
        copy: "Fresh fruit balance with a classic foundation. Premium EVOO keeps it grounded, while pomegranate balsamic adds a bright, juicy finish.",
        why: ["Excellent through salads, grain bowls, and grilled vegetables.","Fruit acidity pairs naturally with chicken and lamb.","A versatile choice for everyday dressing and finishing."] },

      heat_energy: { title: "Heat and Energy", oil: "chilli-extra-virgin-olive-oil", vinegar: "red-wine-liqueur-vinegar",
        copy: "Warm, confident flavour with a savoury backbone. Chilli olive oil brings controlled heat, while red wine liqueur vinegar keeps everything grounded and balanced.",
        why: ["Ideal for pizza drizzles, eggs, noodles, and BBQ.","Red wine vinegar suits meat, sauces, and robust dressings.","A strong pairing for bold, flavour-driven cooking."] },

      luxury: { title: "Luxury Dinner", oil: "truffle-extra-virgin-olive-oil", vinegar: "fig-balsamic-vinegar",
        copy: "Restaurant character at home. Truffle olive oil adds earthy richness, while fig balsamic deepens the finish with fruit sweetness and a savoury edge.",
        why: ["Excellent over fries, mash, risotto, and steak.","Fig balsamic suits roasted pumpkin, lamb, duck, and cheese.","Best used as a finishing touch for maximum aroma."] },

      bbq_smoke: { title: "BBQ and Smoke", oil: "natural-smoked-extra-virgin-olive-oil", vinegar: "red-wine-liqueur-vinegar",
        copy: "Smoky depth with a classic finish. Natural smoked olive oil brings a subtle wood note, paired with red wine liqueur vinegar for sauces, marinades, and grilled dishes.",
        why: ["Perfect for grilled vegetables, mushrooms, and BBQ meats.","Builds complexity without needing a smoker.","A confident base for marinades and bold dressings."] },

      fusion_edge: { title: "Fusion and Edge", oil: "wasabi-extra-virgin-olive-oil", vinegar: "white-wine-liqueur-vinegar",
        copy: "Clean heat with precision. Wasabi olive oil gives a sharp lift that settles smoothly, paired with bright white wine liqueur vinegar for modern seafood and fresh bowls.",
        why: ["Ideal for poke bowls, sushi-style dishes, and seafood.","Bright acidity keeps flavours clean and defined.","A modern pairing for adventurous cooks."] }
    };

    const questions = Array.from(form.querySelectorAll(".pukara-premium-quiz__q"));
    let step = 1;
    let lockedHeight = null;

    function measureAndLockStepHeight() {
      if (!stage) return;
      if (panelWrap && panelWrap.hidden) return;

      const max = questions.reduce((m, q) => Math.max(m, q.scrollHeight), 0);
      if (!max) return;

      lockedHeight = max + 170;
      stage.style.minHeight = lockedHeight + "px";
      stage.classList.add("pukara-stage--lock");
    }

    function unlockForResults() {
      if (!stage) return;
      stage.style.minHeight = "";
      stage.classList.remove("pukara-stage--lock");
    }

    function showStep(n) {
      step = n;
      questions.forEach((q) => (q.hidden = q.getAttribute("data-q") !== String(n)));
      if (backBtn) backBtn.disabled = n === 1;
      if (nextBtn) nextBtn.textContent = n === questions.length ? "Find my match" : "Next";
      if (errorEl) errorEl.textContent = "";
      if (progressEl) progressEl.style.width = Math.round(((n - 1) / questions.length) * 100) + "%";
      if (stepLabel) stepLabel.textContent = "Step " + n + " of " + questions.length;

      if (!lockedHeight) measureAndLockStepHeight();
    }

    function validateStep(n) {
      const fieldset = questions[n - 1];
      const req = fieldset.querySelector("input[required]");
      if (!req) return true;
      return !!form.querySelector('input[name="' + req.name + '"]:checked');
    }

    function getAnswers() {
      const d = new FormData(form);
      return { q1: d.get("q1"), q2: d.get("q2"), q3: d.get("q3"), q4: d.get("q4"), q5: d.get("q5") };
    }

    function scoreAll(a) {
      const s = { classic: 0, italian: 0, summer_table: 0, bright_fresh: 0, tropical_bright: 0, pomegranate_classic: 0, heat_energy: 0, luxury: 0, bbq_smoke: 0, fusion_edge: 0 };

      // Q1
      if (a.q1 === "everyday") { s.classic += 3; s.italian += 1; s.pomegranate_classic += 1; }
      if (a.q1 === "entertaining") { s.summer_table += 2; s.luxury += 2; s.classic += 1; s.pomegranate_classic += 2; }
      if (a.q1 === "bold") { s.heat_energy += 2; s.bbq_smoke += 2; s.italian += 1; }
      if (a.q1 === "fresh") { s.bright_fresh += 3; s.summer_table += 1; s.tropical_bright += 2; s.pomegranate_classic += 2; }
      if (a.q1 === "adventurous") { s.fusion_edge += 3; s.tropical_bright += 2; }

      // Q2 (pomegranate favours rich, not citrus)
      if (a.q2 === "herbaceous") { s.summer_table += 3; s.classic += 1; }
      if (a.q2 === "citrus") { s.bright_fresh += 3; s.tropical_bright += 3; }
      if (a.q2 === "rich") { s.luxury += 4; s.classic += 1; s.pomegranate_classic += 2; }
      if (a.q2 === "smoky") { s.bbq_smoke += 4; s.italian += 1; }
      if (a.q2 === "heat") { s.heat_energy += 4; s.fusion_edge += 1; }

      // Q3 (pomegranate: salads yes, bbq yes, finishing no)
      if (a.q3 === "salads") { s.classic += 2; s.summer_table += 2; s.bright_fresh += 1; s.pomegranate_classic += 3; }
      if (a.q3 === "pasta") { s.italian += 4; s.heat_energy += 1; }
      if (a.q3 === "seafood") { s.bright_fresh += 3; s.fusion_edge += 2; s.tropical_bright += 2; }
      if (a.q3 === "bbq") { s.bbq_smoke += 4; s.heat_energy += 2; s.pomegranate_classic += 2; }
      if (a.q3 === "finishing") { s.luxury += 3; s.classic += 2; s.summer_table += 1; }

      // Q4
      if (a.q4 === "classic") { s.italian += 2; s.bbq_smoke += 1; s.bright_fresh += 1; s.fusion_edge += 1; }
      if (a.q4 === "balanced") { s.classic += 2; s.summer_table += 1; s.tropical_bright += 2; s.pomegranate_classic += 2; }
      if (a.q4 === "rich") { s.luxury += 2; s.classic += 1; s.heat_energy += 1; s.tropical_bright += 1; s.pomegranate_classic += 1; }

      // Q5
      if (a.q5 === "weeknight") { s.classic += 3; s.italian += 2; s.heat_energy += 1; }
      if (a.q5 === "longlunch") { s.summer_table += 2; s.bright_fresh += 2; s.classic += 1; s.pomegranate_classic += 3; }
      if (a.q5 === "datenight") { s.luxury += 3; s.classic += 1; s.italian += 1; }
      if (a.q5 === "summer") { s.summer_table += 3; s.bright_fresh += 2; s.tropical_bright += 2; s.pomegranate_classic += 2; }
      if (a.q5 === "winter") { s.luxury += 2; s.bbq_smoke += 2; s.italian += 1; s.classic += 1; }

      return s;
    }

    function pickWinner(scores) {
      const entries = Object.entries(scores).sort((a, b) => b[1] - a[1]);
      return (entries[0] && entries[0][0]) ? entries[0][0] : "classic";
    }

    async function setCard(kind, handle) {
      const p = products[handle];
      if (!p) return null;

      try { await hydrateProduct(p); } catch (e) {}
      const url = p.url || ("/products/" + handle);

      if (kind === "oil") {
        if (oilLink) oilLink.href = url;
        if (oilTitle) { oilTitle.textContent = p.title || handle; oilTitle.href = url; }
        if (oilPrice) oilPrice.textContent = p.price_formatted || "";
        if (oilImg && p.image) { oilImg.src = p.image; oilImg.alt = p.title || ""; }
        if (oilBuy) oilBuy.href = buildDiscountedRedirectUrl(discountCode, url);
        return p;
      }

      if (vinLink) vinLink.href = url;
      if (vinTitle) { vinTitle.textContent = p.title || handle; vinTitle.href = url; }
      if (vinPrice) vinPrice.textContent = p.price_formatted || "";
      if (vinImg && p.image) { vinImg.src = p.image; vinImg.alt = p.title || ""; }
      if (vinBuy) vinBuy.href = buildDiscountedRedirectUrl(discountCode, url);
      return p;
    }

    function clearList(el) { if (el) el.innerHTML = ""; }
    function addLinkItem(listEl, title, url) {
      const li = document.createElement("li");
      const a = document.createElement("a");
      a.href = url;
      a.textContent = cleanRecipeTitle(title);
      li.appendChild(a);
      listEl.appendChild(li);
    }

    async function fetchArticlesViaSuggest(query, limit) {
      const u = "/search/suggest.json?q=" + encodeURIComponent(query) +
        "&resources[type]=article&resources[limit]=" + encodeURIComponent(String(limit || 3));
      const res = await fetch(u, { headers: { Accept: "application/json" } });
      if (!res.ok) return [];
      const json = await res.json();
      const articles = ((((json || {}).resources || {}).results || {}).articles || []);
      return articles
        .filter(a => a && a.url && a.title)
        .filter(a => !isBlogIndexUrl(a.url) && !isRecipesBlogIndex(a.url))
        .slice(0, limit || 3)
        .map(a => ({ title: a.title, url: a.url }));
    }

    async function fetchArticlesViaHTML(query, limit) {
      const u = "/search?q=" + encodeURIComponent(query) + "&type=article";
      const res = await fetch(u, { headers: { Accept: "text/html" } });
      if (!res.ok) return [];
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      const links = Array.from(doc.querySelectorAll('a[href^="/blogs/"]'))
        .map(a => ({
          title: cleanRecipeTitle((a.textContent || "").trim()),
          url: (a.getAttribute("href") || "").trim()
        }))
        .filter(x => x.url && x.title && x.title.length > 3)
        .filter(x => !isBlogIndexUrl(x.url) && !isRecipesBlogIndex(x.url))
        .filter(x => x.url.split("?")[0].replace(/\/+$/, "").split("/").length >= 4);

      const seen = new Set();
      const out = [];
      for (const l of links) {
        const u2 = l.url.split("?")[0].replace(/\/+$/, "");
        if (seen.has(u2)) continue;
        seen.add(u2);
        out.push({ title: l.title, url: l.url });
        if (out.length >= (limit || 3)) break;
      }
      return out;
    }

    async function loadArticles(query, limit) {
      const seen = new Set();
      const out = [];
      const normalise = (url) => url.split("?")[0].replace(/\/+$/, "").toLowerCase();

      try {
        const suggest = await fetchArticlesViaSuggest(query, limit * 2);
        for (const a of suggest) {
          const key = normalise(a.url);
          if (seen.has(key)) continue;
          seen.add(key);
          out.push(a);
          if (out.length >= limit) return out;
        }
      } catch (e) {}

      try {
        const html = await fetchArticlesViaHTML(query, limit * 2);
        for (const a of html) {
          const key = normalise(a.url);
          if (seen.has(key)) continue;
          seen.add(key);
          out.push(a);
          if (out.length >= limit) break;
        }
      } catch (e) {}

      return out;
    }

    async function renderRecipes(oilProduct, vinProduct) {
      const oilQuery = (oilProduct && oilProduct.title) ? oilProduct.title : "";
      const vinQuery = (vinProduct && vinProduct.title) ? vinProduct.title : "";

      if (!recipesWrap) return;

      if (oilRecipesTitle) oilRecipesTitle.textContent = oilQuery ? ("Featuring " + oilQuery) : "Featuring this olive oil";
      if (vinRecipesTitle) vinRecipesTitle.textContent = vinQuery ? ("Featuring " + vinQuery) : "Featuring this vinegar";

      if (oilRecipesMore) oilRecipesMore.href = "/search?q=" + encodeURIComponent(oilQuery) + "&type=article";
      if (vinRecipesMore) vinRecipesMore.href = "/search?q=" + encodeURIComponent(vinQuery) + "&type=article";

      clearList(oilRecipesList);
      clearList(vinRecipesList);

      if (!oilQuery && !vinQuery) { recipesWrap.hidden = true; return; }
      recipesWrap.hidden = false;

      try {
        const [oilArticles, vinArticles] = await Promise.all([
          oilQuery ? loadArticles(oilQuery, 3) : Promise.resolve([]),
          vinQuery ? loadArticles(vinQuery, 3) : Promise.resolve([])
        ]);

        if (oilArticles.length && oilRecipesList) oilArticles.forEach(a => addLinkItem(oilRecipesList, a.title, a.url));
        if (!oilArticles.length && oilRecipesList) addLinkItem(oilRecipesList, "Explore recipes and articles", "/search?q=" + encodeURIComponent(oilQuery) + "&type=article");

        if (vinArticles.length && vinRecipesList) vinArticles.forEach(a => addLinkItem(vinRecipesList, a.title, a.url));
        if (!vinArticles.length && vinRecipesList) addLinkItem(vinRecipesList, "Explore recipes and articles", "/search?q=" + encodeURIComponent(vinQuery) + "&type=article");
      } catch (e) {
        if (oilRecipesList) addLinkItem(oilRecipesList, "Explore recipes and articles", "/search?q=" + encodeURIComponent(oilQuery) + "&type=article");
        if (vinRecipesList) addLinkItem(vinRecipesList, "Explore recipes and articles", "/search?q=" + encodeURIComponent(vinQuery) + "&type=article");
      }
    }

    async function renderResult(key) {
      const r = RESULTS[key] || RESULTS.classic;

      if (resultTitle) resultTitle.textContent = r.title;
      if (resultCopy) resultCopy.textContent = r.copy;

      if (whyEl) {
        whyEl.innerHTML = "";
        (r.why || []).forEach(t => {
          const li = document.createElement("li");
          li.textContent = t;
          whyEl.appendChild(li);
        });
      }

      const oil = await setCard("oil", r.oil);
      const vin = await setCard("vin", r.vinegar);

      if (panelWrap) panelWrap.hidden = true;
      if (resultWrap) resultWrap.hidden = false;
      if (codeWrap) codeWrap.hidden = false;
      if (statusEl) statusEl.textContent = "";

      unlockForResults();
      renderRecipes(oil, vin);
    }

    if (backBtn) backBtn.addEventListener("click", () => { if (step > 1) showStep(step - 1); });

    nextBtn.addEventListener("click", () => {
      if (!validateStep(step)) {
        if (errorEl) errorEl.textContent = "Please choose an option to continue.";
        return;
      }
      if (step < questions.length) { showStep(step + 1); return; }
      const winner = pickWinner(scoreAll(getAnswers()));
      renderResult(winner);
    });

    if (copyBtn) {
      copyBtn.addEventListener("click", async () => {
        try { await navigator.clipboard.writeText(discountCode); if (statusEl) statusEl.textContent = "Code copied."; }
        catch (e) { if (codeField) { codeField.focus(); codeField.select(); } if (statusEl) statusEl.textContent = "Select the code and copy manually."; }
      });
    }

    if (restartBtn) {
      restartBtn.addEventListener("click", () => {
        form.reset();
        if (resultWrap) resultWrap.hidden = true;
        if (panelWrap) panelWrap.hidden = false;
        if (codeWrap) codeWrap.hidden = true;
        if (recipesWrap) recipesWrap.hidden = true;

        lockedHeight = null;
        stage && (stage.style.minHeight = "");
        showStep(1);
        measureAndLockStepHeight();
      });
    }

    if (recipesWrap) recipesWrap.hidden = true;
    if (codeWrap) codeWrap.hidden = true;

    showStep(1);

    requestAnimationFrame(() => measureAndLockStepHeight());
    window.addEventListener("resize", () => {
      if (panelWrap && !panelWrap.hidden) {
        lockedHeight = null;
        measureAndLockStepHeight();
      }
    }, { passive: true });
  }

  function boot() {
    restoreScroll();
    document.querySelectorAll(".pukara-premium-quiz").forEach(initQuiz);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
